
<ng-container [ngSwitch]="shellMode">
  <main *ngSwitchCase="'tenant-loading'" class="platform-state" aria-labelledby="loading-heading" aria-live="polite" aria-busy="true">
    <div class="platform-panel state-panel">
      <mat-spinner diameter="48"></mat-spinner>
      <h1 id="loading-heading">Loading league</h1>
      <p>Please wait while we prepare this league.</p>
    </div>
  </main>

  <main *ngSwitchCase="'tenant-error'" class="platform-state" aria-labelledby="error-heading">
    <div class="platform-panel state-panel" role="alert">
      <mat-icon class="state-icon" aria-hidden="true">error_outline</mat-icon>
      <h1 #errorHeading id="error-heading" tabindex="-1">League unavailable</h1>
      <p>{{ tenantErrorMessage }}</p>
      <button *ngIf="canRetryTenantBootstrap" mat-flat-button color="primary" type="button" (click)="retryTenantBootstrap()">Try again</button>
      <a mat-flat-button color="primary" href="/">Back to home</a>
    </div>
  </main>

  <ng-container *ngSwitchDefault>
    <app-header *ngIf="!hideChrome && !isScorekeeperRoute"></app-header>
    <main [ngClass]="{'admin-route': isAdminRoute, 'league-route': isLeagueRoute, 'invite-route': isInviteRoute, 'portal-route': hideChrome, 'scorekeeper-route': isScorekeeperRoute}">
      <router-outlet></router-outlet>
    </main>
  </ng-container>
</ng-container>
